<div class="m-3 m-lg-4 card">


  <div class="row marginRow">
    <div class="col-6">
      <label for="ano">Ano: </label>
      <input [(ngModel)]="ano" type="number" id="ano" name="ano" min="2022" max="3000" class="form-control">
    </div>
    <div class="col-6">
      <div class="card-footer d-flex col-12 justify-content-end bg-white divButton">
        <button [disabled]="ano==null || ano==undefined" (click)="filtrar()"
          class="btn btn-primary btn-icon px-5 buttonFilter">
          <i class="mdi mdi-magnify" style="font-size: initial;"></i>
          <span>Filtrar</span>
        </button>
      </div>
    </div>
  </div>

  <div class="table-responsive-lg">
    <div class="row">
      <p-table #dt [columns]="cols"
          styleClass="p-datatable-responsive-demo table table-striped table-hover table-responsive-md p-datatable-gridlines p-mt-3"
          [value]="tabledata" [paginator]="true" [rows]="20" [showCurrentPageReport]="true"
          selectionMode="single" [(selection)]="faturamento" [first]="first" [scrollable]="true">

        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of cols"  [pSortableColumn]="col.field">
              {{col.header}}<p-sortIcon [field]="col.field" class="alignRight"></p-sortIcon>
            </th>

            <th width="580px" >
              Arquivos
            </th>

          </tr>
          <tr>
            <th >
              <p-columnFilter type="text" [field]="cols[0].field" [showMenu]="false"></p-columnFilter>
            </th>
            <th >
              <p-columnFilter type="text" [field]="cols[1].field" [showMenu]="false"></p-columnFilter>
            </th>
            <!-- <th >
              <p-columnFilter type="text" [field]="cols[2].field" [showMenu]="false"></p-columnFilter>
            </th> -->
            <th >
              <p-columnFilter type="text" [field]="cols[2].field" [showMenu]="false"></p-columnFilter>
            </th>
            <th width="580px">
            </th>
          </tr>
          
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="index" let-rowIndex="rowIndex">
          <tr [pSelectableRow]="rowData">

            <td >{{rowData.mesStr}}</td>
            <td *ngIf="rowData.valorBoleto != null" >R$ {{rowData.valorBoleto | number:'1.2-2'}}</td>
            <td *ngIf="rowData.valorBoleto == null">Não Gerado</td>
            <!-- <td>
              <span *ngIf="rowData.statusBoleto=='canceled'" class="text-danger"><i class="mdi mdi-circle-medium"style="font-size:x-large"></i>Cancelado</span>
              <span *ngIf="rowData.statusBoleto=='paid'" class="text-success"><i class="mdi mdi-circle-medium"style="font-size:x-large"></i>Pago</span>
              <span *ngIf="rowData.statusBoleto=='waiting_approval'" class="text-warning"><i class="mdi mdi-circle-medium"style="font-size:x-large"></i>Aguardando Remessa</span>
              <span *ngIf="rowData.statusBoleto=='reserved'" class="text-warning"><i class="mdi mdi-circle-medium"style="font-size:x-large"></i>Reservado</span>
              <span *ngIf="rowData.statusBoleto=='pending-analysis'" class="text-warning"><i class="mdi mdi-circle-medium"style="font-size:x-large"></i>Análise Pendente</span>
              <span *ngIf="rowData.statusBoleto=='error'" class="text-danger"><i class="mdi mdi-circle-medium"style="font-size:x-large"></i>Ocorreu Erro</span>
              <span *ngIf="rowData.statusBoleto=='completed'" class="text-success"><i class="mdi mdi-circle-medium"style="font-size:x-large"></i>Completado</span>
              <span *ngIf="rowData.statusBoleto=='pending'" class="text-warning"><i class="mdi mdi-circle-medium"style="font-size:x-large"></i>Aguardando Pagamento</span>
              <span *ngIf="(rowData.statusBoleto!='waiting_approval' && 
                          rowData.statusBoleto!='pending' && 
                          rowData.statusBoleto!='paid' && 
                          rowData.statusBoleto!='canceled' && 
                          rowData.statusBoleto=='pending-analysis' &&
                          rowData.statusBoleto!='reserved' && 
                          rowData.statusBoleto!='error' && 
                          rowData.statusBoleto!='completed') || rowData.statusBoleto == 'others'" class="text-primary"><i class="mdi mdi-circle-medium"style="font-size:x-large"></i>OUTROS</span>
              <span *ngIf="rowData.statusBoleto == null" class="text-primary">Não Gerado</span>
            </td> -->
            <td *ngIf="rowData.valorBoleto != null">{{rowData.dataVencimentoBoleto | date:'dd/MM/yyyy HH:mm'}}</td>
            <td *ngIf="rowData.valorBoleto == null">Não Gerado</td>

            <td  width="580px">
              <div class="d-flex align-items-center justify-content-end">

                <button class="button-blue"
                  data-toggle="tooltip" data-placement="bottom" title="Boleto" [disabled]="rowData.linkPdfBoleto == null">
                  <a class="btn btn-sm btn-icon" [attr.href]="rowData.linkPdfBoleto">
                    <i class="mdi mdi-barcode-scan">
                    </i>Boleto
                  </a>

                </button>

                <button class="button-blue"
                  data-toggle="tooltip" data-placement="bottom" title="Log de Consultas"  [disabled]="rowData.linkXlsx == null">
                  <a class="btn btn-sm btn-icon" [attr.href]="rowData.linkXlsx">
                    <i class="mdi mdi-file-document">
                    </i>Log de Consultas
                  </a>

                </button>
              

                <button class="button-blue"
                  data-toggle="tooltip" data-placement="bottom" title="Nota Fiscal Eletrônica" [disabled]="rowData.linkPdfNfe == null">
                  <a class="btn btn-sm btn-icon" [attr.href]="rowData.linkPdfNfe">
                    <i class="mdi mdi-barcode-scan">
                    </i>Nota Fiscal Eletrônica
                  </a>

                </button>

                <button data-toggle="tooltip"
                  data-placement="bottom" title="Faturamento" class="button-blue" [disabled]="rowData.linkPdf == null">
                  <a [attr.href]="rowData.linkPdf" class="btn btn-sm btn-icon">
                    <i class="mdi mdi-file-document"></i>Faturamento
                  </a>
                </button>

              </div>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length + 1">
              Nenhum faturamento foi encontrado
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>



  </div>

</div>